interface DoubleCheckProps {
  className?: string;
}

export default function DoubleCheck({ className }: DoubleCheckProps) {
  return (
    <svg
      width="18"
      height="11"
      viewBox="0 0 18 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M12.3682 1L4 9.75004L1.5 6.00004M16.5 1.50004L8.64286 9.75004L7.5 8.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
